<template>
  <div class="step-by-step button is-small" @click.stop="$root.$emit('instruction-step-by-step')">
    <span class="icon" v-if="isMobile"><i class="fa fa-expand"/></span>
    <span v-else>{{text}}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  },

  computed: {
    isMobile(){
      return window.innerWidth <= 768
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/recipe/InstructionStepByStep.vue